export default "__VITE_ASSET__BcZMKR1x__"